import { Box } from '@chakra-ui/react'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import CartPage from './Cart/CartPage'
import ConsratsPage from './Cart/CongratsPage'
import DeliveryPage from './Cart/DeliveryPage'
import OtpPgae from './Cart/OtpPage'
import PaymentPage from './Cart/PayemntPage'
import Summary from './Cart/Summary'
import PrivateRoutes from './Context/PrivateRoutes'
import NotFound from './Error/NotFound'
import Home from './Home/Home'
import { Login } from './Login/Login'
import { Signup } from './Login/SignUp'
import OrderPage from './OrderPage/OrderPage'
import Products from './Products.jsx/Products'
import Viewpage from './ProductsView.jsx/Viewpage'


import AdminProducts from './Admin/AdminProducts'
import Dashboard from './Admin/Dashboard'
import AdminCategories from './Admin/AdminCategories'
import PrivacyPolicy from './LegalPages/PrivacyPolicy'
import Disclaimer from './LegalPages/Disclaimer'
import ShippingPolicy from './LegalPages/ShippingPolicy'
import TermsAndCondition from './LegalPages/TermsAndCondition'
import NavneetSoftwares from './Softwares/NavneetSoftwares'
import SupremeAI from './Softwares/SupremeAI'
import Digileagal from './Softwares/Digileagal'
import Taxman from './Softwares/Taxman'
import DltPublications from './Softwares/DLT'
import LegitQuest from './Softwares/LegitQuest'
import CDJLawJournal from './Softwares/CDJLawJournal'
import DandT from './Softwares/DandT'
import LMS from './Softwares/LMS'
import LegalResearchAssistance from './Softwares/LegalResearchAssistance'
import About from './About/Abouts'
import Contactus from './About/Contactus'
import PaymentCallback from './Cart/PaymentCallback'
import PaymentFailed from './Cart/PaymentFaild'
import RecommendedLink from './Softwares/RecommendedLink'
import AdminClothes from './Admin/AdminClothes'
import AdminFurniture from './Admin/AdminFurniture'
import { AuthProvider } from './Context/AdminAuthContext'
import PaymentCallbackHdfc from './Cart/PaymentCallbackHdfc'
import Invoices from './Invoices/Invoices'
import CreateInvoice from './Admin/CreateInvoice'
import AdminSoftwares from './Admin/AdminSoftwares'
import ForgotPassword from './Login/ForgotPassword'
import AdminJournalAndBounds from './Admin/AdminJournalAndBounds'
import AdminCustomerList from './Admin/AdminCustomerList'
import AdminStaffManagment from './Admin/AdminStaffManagment'
import Invoiceadmin from './Invoices/Invoiceadmin'
import MyProfile from './MyProfile/MyProfile'


const AllRoutes = () => {
    return (
        <>
            <AuthProvider>
  

            <Routes>
                <Route path='/' element={<Home />} />
                
                <Route path='/products/:category_name' element={<Products />} />
                <Route path='/products' element={<Products />} />
                <Route path='/forgotpassword' element={<ForgotPassword/>} />
                <Route path='/products/view/:item_id' element={<Viewpage />} />
                <Route path='/cart' element={<CartPage />} />
               
<Route path="/admin" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <Dashboard /> : <NotFound />} />
<Route path="/admincategory" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <AdminCategories /> : <NotFound />} />
<Route path="/adminproducts" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <AdminProducts /> : <NotFound />} />
<Route path="/staffmanagment" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <AdminStaffManagment /> : <NotFound />} />
<Route path="/admincustomers" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <AdminCustomerList /> : <NotFound />} />
<Route path="/AdminJournalAndBounds" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <AdminJournalAndBounds /> : <NotFound />} />
<Route path="/adminclothes" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <AdminClothes /> : <NotFound />} />
<Route path="/adminsoftware" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <AdminSoftwares /> : <NotFound />} />
<Route path="/adminfurniture" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <AdminFurniture /> : <NotFound />} />
<Route path="/create-invoice" element={localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'staff' ? <CreateInvoice /> : <NotFound />} />

                <Route path='/disclaimer' element={<Disclaimer />} />
                <Route path='/termsandcondition' element={<TermsAndCondition />} />
                <Route path='/privacy' element={<PrivacyPolicy />} />
                <Route path='/shippingpolicy' element={<ShippingPolicy />} />
                <Route path="/delivery" element={
                    <PrivateRoutes>
                        <DeliveryPage />
                    </PrivateRoutes>
                } />
                <Route path="/software" element={<NavneetSoftwares />} /> 
                <Route path="/RecommendedLink" element={<RecommendedLink />} /> 
                <Route path="/supremeAi" element={<SupremeAI />} /> 
                <Route path="/digileagal" element={<Digileagal />} /> 
                <Route path="/DltPublications" element={<DltPublications />} /> 
                <Route path="/LegitQuest" element={<LegitQuest/>} /> 
                <Route path="/CDJLawJournal" element={<CDJLawJournal/>} /> 
                <Route path="/taxman" element={<Taxman />} /> 
                <Route path="/summary" element={<Summary />} />
                <Route path="/dandt" element={<DandT />} />
                <Route path="/lms" element={<LMS />} />
                <Route path="/leagleReaserch" element={<LegalResearchAssistance />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contactus />} />
                <Route path="/payment-success" element={<PaymentCallback />} />
                <Route path="/payment-success-hdfc" element={<PaymentCallbackHdfc />} />
                <Route path="/payment-failure" element={<PaymentFailed />} />
                <Route path="/faild" element={<PaymentFailed />} />
                <Route path="/failed" element={<PaymentFailed />} />
                <Route path="/invoice" element={<Invoices />} />
                <Route path="/invoiceadmin" element={<Invoiceadmin />} />
                <Route path="/payment" element={
                    <PrivateRoutes>
                        <PaymentPage />
                    </PrivateRoutes>
                } />
                <Route path="/otp" element={
                    <OtpPgae />
                } />
                <Route path="/congo" element={
                    <ConsratsPage />
                } />
                <Route path='/orderpage' element={
                    <PrivateRoutes>
                        <OrderPage />
                    </PrivateRoutes>
                } />
                <Route path='/myprofile' element={
                    <PrivateRoutes>
                        <MyProfile />
                    </PrivateRoutes>
                } />
                <Route path='/signup' element={

                    <Signup />

                } />
                <Route path='/login' element={

                    <Login />

                } />


                <Route path='*' element={<NotFound />}>

                </Route>
            </Routes>
</AuthProvider>
        </>
    )
}

export default AllRoutes